module.exports = __webpack_public_path__ + "media/about/brittany-b452a2b1.jpg";